import React, { useRef } from 'react';
import { LexicalEditor } from 'lexical';
import { Popover, PopoverBody } from 'reactstrap';
import { useToggle } from '@hooks/useToggle';
import { ColorPicker } from './ColorPicker';
import { applyStyleToSelection, TOOLBAR_POPOVER_PROPS } from './utils';

interface FontColorDropDownProps {
  editor: LexicalEditor;
  fontColor: string;
}

export const FontColorDropDown = ({
  editor,
  fontColor,
}: FontColorDropDownProps): React.ReactNode => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [popoverOpen, toggle] = useToggle(false);

  const handleColorChange = (color: string) => {
    applyStyleToSelection(editor, { color });
  };

  return (
    <>
      <button
        ref={buttonRef}
        onClick={toggle}
        className='btn btn-transparent btn-sm border-0 flex-shrink-0 d-flex flex-column align-items-center justify-content-center'
        type='button'
        aria-label='Font color'
        aria-haspopup='true'
        aria-expanded={popoverOpen}
      >
        <i className='fal fa-font text-ThemeIconSecondary' />
        <div className='font-color-indicator' style={{ backgroundColor: fontColor }} />
      </button>
      <Popover
        {...TOOLBAR_POPOVER_PROPS}
        isOpen={popoverOpen}
        toggle={toggle}
        target={buttonRef}
      >
        <PopoverBody className='editor__toolbar__submenu p-0'>
          <ColorPicker color={fontColor} onChange={handleColorChange} />
        </PopoverBody>
      </Popover>
    </>
  );
};
